import { Component } from "@angular/core";
import { BaseInsuranceComponent } from "../base/base.component";
import { NxAccordionModule } from "@aposin/ng-aquila/accordion";
import { ResultItemComponent } from "../../result-item/result-item.component";
import { TranslationComponent } from "../../translation/translation.component";

@Component({
  selector: "app-cyber-insurance",
  standalone: true,
  imports: [NxAccordionModule, ResultItemComponent, TranslationComponent],
  templateUrl: "./cyber-insurance.component.html",
  styleUrl: "./cyber-insurance.component.css",
})
export class CyberInsuranceComponent extends BaseInsuranceComponent {}
